<template>
  <v-container fluid class="pa-0">
    <!-- Header -->
    <v-sheet class="reports-hero" dark>
      <v-container class="py-8">
        <v-row align="center">
          <v-col cols="12" md="8">
            <div class="d-flex align-center">
              <v-icon large class="mr-3">mdi-chart-line</v-icon>
              <div>
                <div class="text-h4 font-weight-bold">Reports</div>
                <div class="text-subtitle-1 opacity-90">
                  Real time data, simple and fast.
                </div>
              </div>
            </div>

            <v-alert
              class="mt-5"
              dense
              outlined
              color="white"
              border="left"
              icon="mdi-storefront"
            >
              Want reports for just one store? Open the store profile to see
              store specific reports.
            </v-alert>
          </v-col>

          <v-col cols="12" md="4" class="text-md-right mt-4 mt-md-0">
            <v-btn
              large
              class="text-capitalize font-weight-medium"
              to="/location/dashboard"
            >
              <v-icon left>mdi-format-list-bulleted</v-icon>
              Store List
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <!-- Content -->
    <v-container class="py-6">
      <v-row dense>
        <v-col cols="12" md="6">
          <v-card
            class="report-card"
            outlined
            hover
            to="sales"
          >
            <v-card-text class="pa-6">
              <div class="d-flex align-start">
                <v-avatar size="44" class="mr-4 report-icon">
                  <v-icon>mdi-cash-register</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-h6 font-weight-bold mb-1">
                    Sales Summary
                  </div>
                  <div class="text-body-2 grey--text text--lighten-1">
                    View sales totals, trends, and breakdowns by location and by
                    employee.
                  </div>

                  <div class="mt-4 d-flex align-center">
                    <v-chip small class="mr-2" outlined>
                      By Location
                    </v-chip>
                    <v-chip small outlined>
                      By Employee
                    </v-chip>

                    <v-spacer />
                    <v-icon class="grey--text text--lighten-1">
                      mdi-chevron-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card
            class="report-card"
            outlined
            hover
            to="timeClock"
          >
            <v-card-text class="pa-6">
              <div class="d-flex align-start">
                <v-avatar size="44" class="mr-4 report-icon">
                  <v-icon>mdi-clock-check</v-icon>
                </v-avatar>

                <div class="flex-grow-1">
                  <div class="text-h6 font-weight-bold mb-1">
                    TimeClock Summary
                  </div>
                  <div class="text-body-2 grey--text text--lighten-1">
                    Track hours, shifts, and attendance by location and by
                    employee.
                  </div>

                  <div class="mt-4 d-flex align-center">
                    <v-chip small class="mr-2" outlined>
                      Hours
                    </v-chip>
                    <v-chip small outlined>
                      Attendance
                    </v-chip>

                    <v-spacer />
                    <v-icon class="grey--text text--lighten-1">
                      mdi-chevron-right
                    </v-icon>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Optional future card (kept hidden but ready) -->
        <!--
        <v-col cols="12" md="6">
          <v-card class="report-card" outlined hover to="expenses">
            <v-card-text class="pa-6">
              <div class="d-flex align-start">
                <v-avatar size="44" class="mr-4 report-icon">
                  <v-icon>mdi-receipt-text</v-icon>
                </v-avatar>
                <div class="flex-grow-1">
                  <div class="text-h6 font-weight-bold mb-1">
                    Expenses Summary
                  </div>
                  <div class="text-body-2 grey--text text--lighten-1">
                    View expense totals and trends by date range.
                  </div>
                  <div class="mt-4 d-flex align-center">
                    <v-chip small outlined>Date Range</v-chip>
                    <v-spacer />
                    <v-icon class="grey--text text--lighten-1">mdi-chevron-right</v-icon>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        -->
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "reports-home",
};
</script>

<style scoped>
.reports-hero {
  background: linear-gradient(135deg, #1b5e20 0%, #2e7d32 45%, #43a047 100%);
  border-bottom-left-radius: 18px;
  border-bottom-right-radius: 18px;
}

.report-card {
  border-radius: 16px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.report-card:hover {
  transform: translateY(-2px);
}

.report-icon {
  background: rgba(46, 125, 50, 0.15);
  color: #2e7d32;
}
</style>